import React from 'react';
import UserStack from 'App/components/UserStack';

export default function AccountManagerColumn({ account, createNewAccountRow }) {
	if (!account.users) {
		return null;
	}

	const hasGroupTreeVirtualizedList = Tools.FeatureHelper.hasSoftDeployAccess('GROUP_TREE_VIRTUALIZED_LIST');
	const Component = hasGroupTreeVirtualizedList && !createNewAccountRow ? 'div' : 'td';

	return (
		<Component
			className={`DataSourceColumn accountManager ${
				hasGroupTreeVirtualizedList && !createNewAccountRow ? 'align-items-center' : ''
			}`}
		>
			<UserStack users={account.users} />
		</Component>
	);
}
